import { render, staticRenderFns } from "./TextEditorControl.vue?vue&type=template&id=4820182e&scoped=true"
import script from "./TextEditorControl.vue?vue&type=script&lang=js"
export * from "./TextEditorControl.vue?vue&type=script&lang=js"
import style0 from "./TextEditorControl.vue?vue&type=style&index=0&id=4820182e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4820182e",
  null
  
)

export default component.exports